export const OaSdlController = {
    index(): void {},
};
